import { render, staticRenderFns } from "./IpaasSoftwareDialog.vue?vue&type=template&id=bb6a9288&"
import script from "./IpaasSoftwareDialog.vue?vue&type=script&lang=js&"
export * from "./IpaasSoftwareDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports